/**
 * BarChart — DS Chart
 */

import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend,
} from 'chart.js';
import styles from './BarChart.module.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartProps {
  labels: string[];
  datasets: { label: string; data: number[]; color?: string }[];
  title?: string;
  horizontal?: boolean;
  height?: number;
  className?: string;
}

export function BarChart({ labels, datasets, title, horizontal = false, height = 240, className = '' }: BarChartProps) {
  const colors = ['#9333ea', '#16a34a', '#2563eb', '#d97706'];
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {title && <h4 className={styles.title}>{title}</h4>}
      <div style={{ height }}>
        <Bar
          data={{
            labels,
            datasets: datasets.map((ds, i) => ({
              label: ds.label,
              data: ds.data,
              backgroundColor: `${ds.color ?? colors[i % colors.length]}cc`,
              borderColor: ds.color ?? colors[i % colors.length],
              borderWidth: 1,
              borderRadius: 4,
            })),
          }}
          options={{
            responsive: true, maintainAspectRatio: false,
            indexAxis: horizontal ? 'y' : 'x',
            plugins: { legend: { position: 'top', labels: { font: { family: 'Inter' }, boxWidth: 12 } } },
            scales: { x: { grid: { color: '#f3f4f6' } }, y: { grid: { color: '#f3f4f6' } } },
          }}
        />
      </div>
    </div>
  );
}
